import request from '../../../api/request';
import { PaginationQueryDto } from '../../../types/paginationRequestType';
import { Survey, SurveyListResponseType, SurveyStatus } from './types/Survey';
import {
  CreateSurveyDraftRequest,
  SurveyDraftListResponseType,
  SurveyDraftResponseType,
} from './types/SurveyDraft';
import { FormDataResponse } from './types/SurveyDraftFormData';

/**
 * SURVEYS DRAFT SECTION
 */
const SURVEYS_DRAFT = {
  LIST: () => `maintainers-portal/management-tools/surveys/drafts`,
  GET: (id: string) =>
    `maintainers-portal/management-tools/surveys/drafts/${id}`,
  FORM_DATA: () => `maintainers-portal/management-tools/surveys/form-data`,
  CREATE: () => `maintainers-portal/management-tools/surveys/drafts`,
  UPDATE: (id: string) =>
    `maintainers-portal/management-tools/surveys/drafts/${id}`,
  DELETE: (id: string) =>
    `maintainers-portal/management-tools/surveys/drafts/${id}`,
  COPY: (id: string) =>
    `maintainers-portal/management-tools/surveys/drafts/${id}/copy`,
};
export async function getFormData() {
  return request<FormDataResponse>(SURVEYS_DRAFT.FORM_DATA(), {
    method: 'GET',
  });
}

export async function getDraftSurvey(id: string) {
  return request<SurveyDraftResponseType>(SURVEYS_DRAFT.GET(id), {
    method: 'GET',
  });
}

export async function getDraftSurveys(params: PaginationQueryDto<any>) {
  return request<SurveyDraftListResponseType>(SURVEYS_DRAFT.LIST(), {
    method: 'GET',
    params,
  });
}

export async function createSurveyDraft(data: CreateSurveyDraftRequest) {
  return request(SURVEYS_DRAFT.CREATE(), {
    method: 'POST',
    data,
  });
}

export async function updateSurveyDraft(
  id: string,
  data: CreateSurveyDraftRequest,
) {
  return request(SURVEYS_DRAFT.UPDATE(id), {
    method: 'PUT',
    data,
  });
}

export async function deleteSurveyDraft(id: string) {
  return request(SURVEYS_DRAFT.DELETE(id), {
    method: 'DELETE',
  });
}

export async function copySurveyDraft(id: string) {
  return request(SURVEYS_DRAFT.COPY(id), {
    method: 'POST',
  });
}

/**
 * SURVEYS SECTION
 */
const SURVEYS = {
  LIST: () => `maintainers-portal/management-tools/surveys`,
  GET: (id: string) => `maintainers-portal/management-tools/surveys/${id}`,
  FORM_DATA: () => `maintainers-portal/management-tools/surveys/form-data`,
  CREATE: () => 'maintainers-portal/management-tools/surveys',
  UPDATE: (id: string) => `maintainers-portal/management-tools/surveys/${id}`,
  UPDATE_STATUS: (id: string) =>
    `maintainers-portal/management-tools/surveys/${id}/status`,
  DELETE: (id: string) => `maintainers-portal/management-tools/surveys/${id}`,
  COPY: (id: string) =>
    `maintainers-portal/management-tools/surveys/${id}/copy`,
};

export async function createSurvey(data: CreateSurveyDraftRequest) {
  return request(SURVEYS.CREATE(), {
    method: 'POST',
    data,
  });
}

export async function updateSurvey(id: string, data: CreateSurveyDraftRequest) {
  return request(SURVEYS.UPDATE(id), {
    method: 'PUT',
    data,
  });
}

//obtener encuestas publicadas(borradores llevados a encuestas)
export async function getPublishedSurveys(params: PaginationQueryDto<any>) {
  return request<SurveyListResponseType>(SURVEYS.LIST(), {
    method: 'GET',
    params,
  });
}

export async function getSurvey(id: string) {
  return request<Survey>(SURVEYS.GET(id), {
    method: 'GET',
  });
}

export async function updateSurveyStatus(
  id: string,
  data: { status: SurveyStatus },
) {
  return request(SURVEYS.UPDATE_STATUS(id), {
    method: 'PUT',
    data,
  });
}

export async function copySurvey(id: string) {
  return request(SURVEYS.COPY(id), {
    method: 'POST',
  });
}
